export default __webpack_public_path__ + "static/img-waterdrip-capital-990af5792485f96b82167fdeb32bdeba.png";